export const buildFormDefinition = <T>(et: {
    [K in keyof T]: FieldDefinition;
}) => et;
